import { Modal } from 'bootstrap'
import { Grid } from 'gridjs'
import { appendInputGroup, createTable } from '../General/utils'

const initialise = () => {
	const element = document.getElementById('ClientLeadsTable') as HTMLTableElement
	const renderedID = createTable(element) as string
	new Grid({
		pagination: {
			limit: 500
		},
		sort: true,
		search: true,
		resizable: true,
		language: {
			search: {
				placeholder: 'Search...'
			},
			pagination: {
				previous: '<',
				next: '>',
				showing: '😃 Displaying',
				results: () => 'Records'
			}
		},
		from: element
	}).render(document.getElementById(renderedID)!)

	appendInputGroup(element.getAttribute('name')!)

	const btnAddRecord = document.querySelector('.btnAddRecord') as HTMLButtonElement
	btnAddRecord.addEventListener('click', () => {
		const addRecordDiv = document.getElementById('AddRecord') as HTMLDivElement
		const addRecord = new Modal(addRecordDiv, {
			backdrop: true,
			keyboard: true
		})
		addRecord.show()
	})
}
window.addEventListener('load', () => {
	initialise()
})
